var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { Center, Flex, Spacer, useRecipe } from "@chakra-ui/react";
import { useContext } from "react";
import { useDetectMobileViewPort } from "@/components/cortex/hooks/useDetectMobileViewPort";
import { HeaderLinks } from "./HeaderLinks";
import { HeaderLogoWrapper } from "./HeaderLogoWrapper";
import { HeaderMenu } from "./HeaderMenu";
export function Header() {
    var logo = useContext(GlobalContext).properties.logo;
    var headerRecipe = useRecipe({ key: "Header" });
    var styles = headerRecipe();
    var isMobile = useDetectMobileViewPort().isMobile;
    return (_jsx(Center, __assign({ as: "header", id: "job-board-header" }, { children: _jsxs(Flex, __assign({ css: styles }, { children: [_jsx(HeaderLogoWrapper, __assign({}, logo)), _jsx(Spacer, {}), isMobile ? _jsx(HeaderMenu, {}) : _jsx(HeaderLinks, {})] })) })));
}
